export class PermissionConfig {
    // user type
    public static USER_SYS_ADMIN_TYPE = 0; //Admin hệ thống
    public static USER_ENTERPRISE_ADMIN_TYPE = 1; //Admin doanh nghiệp
    public static USER_ENTERPRISE_STAFF_TYPE = 2; //Người dùng doanh nghiệp
    public static USER_ENTERPRISE_CUSTOMER_TYPE = 3; //Khách hàng doanh nghiệp
    public static USER_ENTERPRISE_DOCUMENT = 5; //KH Cá nhân
    public static USER_WAITING_DOCUMENT = 6;
    public static USER_CUSTOMER_PERSON = 5; //Khách hàng Cá nhân -> khách hàng cuối
    public static USER_CUSTOMER_ENTERPRISE = 4; //Người dùng của Khách hàng doanh nghiệp
    // feature group
    public static EN_ADMIN_ENTERPRISE_INFO_MANAGE = 1;
    public static EN_ADMIN_CETIFICATE_MANAGE = 5;
    public static EN_CETIFICATE = 1;
    public static EN_ADMIN_BRANCH_MANAGE = 1;
    public static EN_ADMIN_GROUP_USER_MANAGE = 2;
    public static EN_ADMIN_USER_MANAGE = 2;
    public static EN_ADMIN_DEPARTMENT = 2;
    public static EN_ADMIN_MATERIAL_SAMPLE_MANAGE = 6;
    public static EN_ADMIN_CUSTOMER_MANAGE = 4;
    public static EN_ADMIN_MATERIAL_MANAGE = 3;
    public static EN_MANAGER_DOC = 3;
    public static SYS_ADMIN_ENTERPRISE_INFO_MANAGE = 9;
    public static SYS_ADMIN_USER_MANAGE = 10;
    public static SYS_ADMIN_MATERIAL_SAMPLE_MANAGE = 11;
    public static EN_ADMIN_DOCUMENT = 6;
}

export const PERMISS_DIVISION = [
    'ae.qlttdn',
    'ae.qlttnd',
    'ae.qlhddt',
    '401.tmkh',
    '402.xdskh',
    '403.cntbdskh',
    '404.qlnkh',
    '405.xdlkh',
    '406.xmnkh'
]

export const PERMISS_DIVISION_DATA_OLD = [
    'ae.qlttdn',
    'ae.qlttnd',
    'ae.qlhddt',
    'ae.qlttkh'
]
